import { BaseHook } from './base.hook';

export class CredentialsPasswordHook extends BaseHook {

  static path = 'Credentials.Credentials_Password';

  static execute(path, value, actions) {
    // Get current values
    const confirm = actions.getData('Credentials.Credentials_Confirm_Password');
    const hint = actions.getData('Credentials.Credentials_Password_Hint');

    if (confirm != null) {
      actions.setData('Credentials.Credentials_Confirm_Password', '');
    }

    if (hint != null) {
      actions.setData('Credentials.Credentials_Password_Hint', '');
    }
  }
}

